import { useOptionsStore } from '@shared/model'
import { useOptionsApi } from '@shared/model'

export const useMiddlewareOptionsReady = async (): Promise<boolean> => {
  const optionsStore = useOptionsStore()

  if (!optionsStore.hasData) {
    await useOptionsApi()
  }

  return optionsStore.hasData
}
